import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material';
import { common } from '@mui/material/colors';
import { colors } from 'common/constants';
import React from 'react';
import TimeBasedIntervals from './components/time-based intervals';
import monthlyData from 'configs/plan_configuration_montly.json';
import yearlyData from 'configs/plan_configuration_yearly.json';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ModalConfirmPayment from 'pages/admin/upgrade/components/modal-confirm-payment';
import { listPlanPayment } from 'services/payment.service';
import { currentPlan } from 'services/user.service';
import { handleError } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box mt={3}>{children}</Box>}
        </div>
    );
}

export function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

interface IServicePackage {
    monthly: object;
    yearly: object;
}

interface IServicePackageProps {
    monthTabText?: string;
    yearTabText?: string;
    isUpgrade?: boolean;
}

const ServicePackage: React.FC<IServicePackageProps> = ({
    monthTabText = 'Theo tháng',
    yearTabText = 'Theo năm',
    isUpgrade = false,
}) => {
    const [value, setValue] = React.useState(0);
    const [modalProps, setModalProps] = React.useState({
        open: false,
        priceType: value,
        planType: '',
        monthlyPrice: 0,
        yearlyPrice: 0,
        priceText: '',
        choosePlan: {
            id: 0,
            plan_type: '',
            price_type: '',
        },
    });

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const [data] = React.useState<IServicePackage>({
        monthly: monthlyData,
        yearly: yearlyData,
    });
    const [listPlan, setListPlan] = React.useState<
        {
            id: number;
            plan_type: string;
            price_type: string;
        }[]
    >([]);
    const [clientCurrentPlan, setClientCurrentPlan] = React.useState<{
        plan_type: string;
        price_type: string;
    }>({
        plan_type: '',
        price_type: '',
    });

    const navigate = useNavigate();

    const listUpgrade = React.useMemo(() => {
        const [currentData, unit] =
            value === 0 ? [monthlyData, 'VND/tháng'] : [yearlyData, 'VND/năm'];
        return [
            {
                package: currentData.premier.text,
                price: currentData.premier.price.textShort,
                unit: unit,
                description:
                    'Phân tích hiệu quả và nhiều tính năng phân tích dữ liệu vượt trội',
                packageIncludes: [
                    {
                        name: 'Bao gồm 10.000 phản hồi/tháng',
                        accept: true,
                    },
                    {
                        name: '5 người dùng',
                        accept: true,
                    },
                    {
                        name: (
                            <>
                                Mọi thứ đều có trong gói <b>Cao cấp</b>
                            </>
                        ),
                        accept: true,
                    },
                    {
                        name: 'Theo dõi tỷ lệ chuyển đổi',
                        accept: true,
                    },
                    {
                        name: 'Ưu tiên hỗ trợ trực tuyến',
                        accept: true,
                    },
                ],
                monthlyPrice: monthlyData.premier.price.value,
                yearlyPrice: yearlyData.premier.price.value,
                planType: 'premier',
            },
            {
                package: currentData.advance.text,
                price: currentData.advance.price.textShort,
                unit: unit,
                description:
                    'Dành cho người dùng mới với những tính năng bị giới hạn',
                packageIncludes: [
                    {
                        name: 'Bao gồm 10.000 phản hồi/tháng',
                        accept: true,
                    },
                    {
                        name: '5 người dùng',
                        accept: true,
                    },
                    {
                        name: 'Quản lý người xem',
                        accept: true,
                    },
                    {
                        name: 'Theo dõi tỷ lệ chuyển đổi',
                        accept: false,
                    },
                    {
                        name: 'Ưu tiên hỗ trợ trực tuyến',
                        accept: false,
                    },
                ],
                monthlyPrice: monthlyData.advance.price.value,
                yearlyPrice: yearlyData.advance.price.value,
                planType: 'advance',
            },
            {
                package: currentData.standard.text,
                price: currentData.standard.price.textShort,
                unit: unit,
                description:
                    'Dành cho người dùng mới với những tính năng bị giới hạn',
                packageIncludes: [
                    {
                        name: 'Bao gồm 2.000 phản hồi/tháng',
                        accept: true,
                    },
                    {
                        name: '2 người dùng',
                        accept: true,
                    },
                    {
                        name: 'Quản lý người xem',
                        accept: true,
                    },
                    {
                        name: 'Theo dõi tỷ lệ chuyển đổi',
                        accept: false,
                    },
                    {
                        name: 'Ưu tiên hỗ trợ trực tuyến',
                        accept: false,
                    },
                ],
                monthlyPrice: monthlyData.standard.price.value,
                yearlyPrice: yearlyData.standard.price.value,
                planType: 'standard',
            },
            {
                package: currentData.basic.text,
                price: currentData.basic.price.textShort,
                unit: unit,
                description:
                    'Dành cho người dùng mới với những tính năng bị giới hạn',
                packageIncludes: [
                    {
                        name: 'Bao gồm 100 phản hồi/tháng',
                        accept: true,
                    },
                    {
                        name: '1 người dùng',
                        accept: true,
                    },
                    {
                        name: 'Sử dụng những tính năng cơ bản',
                        accept: true,
                    },
                    {
                        name: 'Theo dõi tỷ lệ chuyển đổi',
                        accept: false,
                    },
                    {
                        name: 'Ưu tiên hỗ trợ trực tuyến',
                        accept: false,
                    },
                ],
                monthlyPrice: monthlyData.basic.price.value,
                yearlyPrice: yearlyData.basic.price.value,
                planType: 'basic',
            },
        ];
    }, [value]);

    React.useEffect(() => {
        const fetchListPlan = async () => {
            try {
                const response = await listPlanPayment({});
                if (response.success) {
                    setListPlan(
                        response.data.plans.map(
                            (item: {
                                attributes: any; // eslint-disable-line @typescript-eslint/no-explicit-any
                            }) => item.attributes
                        )
                    );
                }
            } catch (error) {
                handleError(error);
            }
        };

        const fetchCurrenPlan = async () => {
            try {
                const response = await currentPlan();
                if (response.success) {
                    setClientCurrentPlan(response.data);
                }
            } catch (error) {
                handleError(error);
            }
        };

        fetchListPlan();
        fetchCurrenPlan();
    }, []);

    return (
        <Box>
            <Box sx={{ width: isUpgrade ? '40%' : '20%', mx: 'auto', mt: 3 }}>
                <Tabs
                    centered
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    sx={{
                        border: `1px solid ${colors.main}`,
                        backgroundColor: (theme) => theme.palette.common.white,
                        borderRadius: '50px',
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: '700',
                            color: colors.main,
                        },
                        '& .Mui-selected': {
                            color: `${common.white} !important`,
                            fontWeight: '700',
                            backgroundColor: colors.main,
                            borderRadius: '50px',
                        },
                        '& .MuiTabs-indicator': {
                            display: 'none',
                        },
                    }}
                >
                    <Tab
                        label={monthTabText}
                        {...a11yProps(0)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                    <Tab
                        label={yearTabText}
                        {...a11yProps(1)}
                        disableRipple
                        sx={{ flex: 1 }}
                    />
                </Tabs>
            </Box>
            {isUpgrade && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        width: '90%',
                        gap: 3,
                        my: 7,
                        mx: 'auto',
                    }}
                >
                    {listUpgrade.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                flex: 1,
                                backgroundColor: '#fff',
                                minHeight: 650,
                                borderRadius: '20px',
                                padding: '32px 32px',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '2rem',
                                    mt: 3,
                                }}
                            >
                                {item.package}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    mt: 1,
                                    fontSize: '1.2rem',
                                }}
                            >
                                {item.description}
                            </Typography>
                            <Stack direction="row" alignItems="baseline" mt={2}>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: '4rem',
                                        fontWeight: 700,
                                    }}
                                >
                                    {item.price}
                                </Typography>
                                <Typography component="span">
                                    {item.unit}
                                </Typography>
                            </Stack>
                            {item.planType !== 'basic' && (
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        const findPlan:
                                            | {
                                                  id: number;
                                                  plan_type: string;
                                                  price_type: string;
                                              }
                                            | undefined = listPlan.find(
                                            (plan) =>
                                                plan.plan_type ===
                                                    item.planType &&
                                                plan.price_type ===
                                                    (value === 0
                                                        ? 'month'
                                                        : 'year')
                                        );
                                        navigate({
                                            pathname:
                                                '/admin/service-package-payment',
                                            search: `?planType=${findPlan?.plan_type}&priceType=${
                                                findPlan?.price_type
                                            }`,
                                        });
                                        // setModalProps({
                                        //     open: true,
                                        //     priceType: value,
                                        //     planType: item.planType,
                                        //     monthlyPrice: item.monthlyPrice,
                                        //     yearlyPrice: item.yearlyPrice,
                                        //     priceText: item.price,
                                        //     choosePlan: findPlan || {
                                        //         id: 0,
                                        //         plan_type: '',
                                        //         price_type: '',
                                        //     },
                                        // });
                                    }}
                                    sx={{
                                        width: '100%',
                                        border: `2px solid var(--color-primary)`,
                                        minHeight: 50,
                                        borderRadius: '90px',
                                        textTransform: 'none',
                                        fontSize: '1.2rem',
                                        fontWeight: 700,
                                        '&:hover': {
                                            backgroundColor: 'primary.main',
                                            color: '#fff',
                                        },
                                        mt: 2,
                                        mb: 4,
                                    }}
                                >
                                    {clientCurrentPlan.plan_type ===
                                        item.planType &&
                                    clientCurrentPlan.price_type ===
                                        (value === 0 ? 'month' : 'year')
                                        ? 'Gia hạn'
                                        : 'Đặt mua'}
                                </Button>
                            )}
                            <Typography
                                component={'p'}
                                sx={{
                                    fontSize: '1.2rem',
                                    fontWeight: 700,
                                }}
                            >
                                Gói bao gồm
                            </Typography>
                            <ul
                                style={{
                                    listStyleType: 'none',
                                    padding: 0,
                                    marginTop: '1rem',
                                }}
                            >
                                {item.packageIncludes.map((item, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            fontSize: '1.2rem',
                                        }}
                                    >
                                        {item.accept ? (
                                            <DoneIcon
                                                sx={{
                                                    color: 'green',
                                                }}
                                            />
                                        ) : (
                                            <CloseIcon
                                                sx={{
                                                    color: 'red',
                                                }}
                                            />
                                        )}

                                        <Typography
                                            component="span"
                                            sx={{
                                                fontSize: '1.1rem',
                                                color: item.accept
                                                    ? 'black'
                                                    : '#acacac',
                                            }}
                                        >
                                            {item.name}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </Box>
                    ))}
                </Box>
            )}
            <CustomTabPanel value={value} index={0}>
                <TimeBasedIntervals
                    intervals="monthly"
                    dataJSON={data.monthly}
                    isUpgrade={isUpgrade}
                />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <TimeBasedIntervals
                    intervals="yearly"
                    dataJSON={data.yearly}
                    isUpgrade={isUpgrade}
                />
            </CustomTabPanel>
            {modalProps.open && (
                <ModalConfirmPayment
                    open={modalProps.open}
                    modalProps={modalProps}
                    onClose={() =>
                        setModalProps({ ...modalProps, open: false })
                    }
                />
            )}
        </Box>
    );
};

export default ServicePackage;
